import React from 'react';
import { Field } from 'formik';
import Prototype from 'prop-types';

const Checkbox = props => {
    const { name, onPaste, type, autoComplete, placeholder, label, value, onChange, error, errorText, disabled, id, readOnly, inLine, percentage, maximum, minimum,isToggle,toggleIcon } = props
    const onPastValue = (e) => {
        e.preventDefault();
        return false;
    }
    return (
        <Field name={name} type="checkbox">
            {({ field }) => (
                <div className="custom-control custom-checkbox">
                    <div style={{ display: 'flex', alignItems: 'baseline', flexDirection: 'row-reverse', justifyContent: 'flex-end' }}>
                    <label className="custom-control-label" htmlFor={id}>Agree to<a style={{ textDecoration: 'none', color: 'black'}} href="./Termscondition.pdf"  target="blank">{ label }</a> </label>
                    {/* <label className="custom-control-label" htmlFor={id}>{label} </label> */}
                    <div className="">
                        <input
                            readOnly={readOnly ? true : false}
                            className="form-control"
                            // id={id}
                            id="customControlInline"
                            className="custom-control-input"
                            min={ minimum ? 1 : null }
                            max={ maximum }
                            name={name}
                            type={type}
                            autoComplete={autoComplete}
                            placeholder={placeholder}
                            onPaste={onPaste && onPastValue}
                            value={value}
                            onChange={onChange}
                            disabled={disabled}
                            style={{ display: `${inLine ? '' : 'inline-block'}` }}
                            {...field} />

                        {percentage && <div className="input-group-append">
                            <span className="input-group-text"> &#37; </span>
                        </div>}
                        {isToggle && <span className="password-toggle">{toggleIcon}</span>
                        }
                    </div>
                    </div>

                    {error && <div><small className="text-danger">{errorText}</small></div>}


                </div>
            )}
        </Field>
    );
}
Checkbox.protoType = {
    name: Prototype.string.isRequired,
    type: Prototype.string.isRequired,
    placeholder: Prototype.string,
    label: Prototype.string.isRequired,
    id: Prototype.string.isRequired,
    value: Prototype.string.isRequired,
    errorText: Prototype.string,
    onChange: Prototype.func.isRequired,
    error: Prototype.bool,
    disabled: Prototype.bool
}
export default Checkbox;